import { BOLT_STEPS, CERTAIN_STEPS, STEPS } from '../constants';
import { STEPS_FOUR_STAGES } from '../constants_four_stages';
import PcModelOptionsReviewStep from '../PcModelOptionsReviewStep';
import styles from './styles';
import { useState } from 'react';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';

const PcModelOptionsReview = ({ uid = null, hasPanelPrints }) => {
  let UPDATED_STEPS;
  const { options } = usePcConfigurator();
  const optionsFourStages = ['build', 'ultra-labs', 'accessories (new)'];
  let isInArray = false;

  if (hasPanelPrints) {
    UPDATED_STEPS = BOLT_STEPS;
  } else {
    UPDATED_STEPS = STEPS;
  }

  if (options?.length != 0) {
    isInArray = optionsFourStages.includes(options[0].group_step_new);
    if (isInArray) {
      UPDATED_STEPS = STEPS_FOUR_STAGES;
    }
  }

  const stepsWithoutReview = UPDATED_STEPS.filter((item) => item !== 'review');

  const [expandedIndex, setExpandedIndex] = useState(0);

  return (
    <div className="pc-model-options-review">
      <div className="pc-model-review-section-title">Your Configuration</div>
      {stepsWithoutReview.map((step, index) => {
        const setExpanded = () => {
          if (expandedIndex === index) {
            setExpandedIndex(-1);
          } else {
            setExpandedIndex(index);
          }
        };

        return (
          <PcModelOptionsReviewStep
            key={step}
            step={step}
            setExpanded={setExpanded}
            index={index}
            expandedIndex={expandedIndex}
            uid={uid}
            hasPanelPrints={hasPanelPrints}
          />
        );
      })}
      <style jsx>{styles}</style>
    </div>
  );
};

export default PcModelOptionsReview;
